export const isGoogleUnlockEnabled =
  !!process.env.REACT_APP_GOOGLE_UNLOCK_API_KEY && !!process.env.REACT_APP_GOOGLE_UNLOCK_CLIENT_ID
